module.exports = __webpack_public_path__ + "img/chineseBanner3.33f02d2f.png";